import { createClient } from '@assetsJsModule/client/recruitment';

const client = createClient();

export const getVacancy = (id, preferredCountry) => client.getVacancy(id, preferredCountry)
    .then(response => response.data?.data);

export const getVacancies = preferredCountry => client.getVacancies(preferredCountry);
